import { render, staticRenderFns } from "./order-list.component.vue?vue&type=template&id=3a9cc333&"
import script from "./order-list.component.vue?vue&type=script&lang=ts&"
export * from "./order-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./order-list.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "order-list.component.vue"
export default component.exports